import { LoaderCircle } from 'lucide-react';

import { cn } from '@/lib';

/**
 * @file loader.jsx
 * @description  Loader component covering entire screen
 * @version 0.0.1
 * Created at: 13/08/2025
 * Updated at: 13/08/2025
 */
export const Loader = ({ className }) => {
  return (
    <section
      className={cn(
        'dark:bg-background bg-muted pointer-events-none flex items-center justify-center overflow-hidden backdrop-blur-sm dark:text-white',
        'size-full',
        className
      )}
    >
      <button type="button" className="flex gap-1" disabled>
        <Spinner />
        <span className="sm:text-lg">Loading</span>
        <div className="space-x-1">
          <span className="inline-block size-[0.15rem] rounded-full bg-black dark:bg-white"></span>
          <span className="inline-block size-[0.15rem] rounded-full bg-black dark:bg-white"></span>
          <span className="inline-block size-[0.15rem] rounded-full bg-black dark:bg-white"></span>
        </div>
      </button>
    </section>
  );
};

export const Spinner = ({ className, ...props }) => {
  return <LoaderCircle size={30} className={cn('animate-spin', className)} {...props} />;
};
